export default {
  setFleetTypes(state, payload) {
    state.fleetTypes = payload;
  },
};
